import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon65: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        fillRule="evenodd"
        d="m9.992 0 .415.565a9.385 9.385 0 0 1 1.489 3.136c.34 1.261-.151 2.416-1.395 3.409l-.001.812.217.002c3.086.042 5.885.359 8.398.95a.502.502 0 0 1 .378.402l.007.085v10a.5.5 0 0 1 .09.992l-.09.008H.5a.5.5 0 0 1-.09-.992l.09-.008v-10a.5.5 0 0 1 .385-.487c2.572-.605 5.443-.922 8.615-.952v-.82c-1.256-1.02-1.746-2.175-1.386-3.411A10.706 10.706 0 0 1 9.593.576L9.992 0ZM6.991 12.664l-.022.045c-.698 1.341-1.625 2.076-2.784 2.146L4 14.861c-.997 0-1.83-.475-2.5-1.389v5.889h17l.001-5.849c-.658.888-1.492 1.349-2.501 1.349-1.214 0-2.174-.667-2.879-1.94l-.123-.237-.009.02c-.682 1.344-1.616 2.081-2.8 2.151l-.189.006c-1.207 0-2.165-.666-2.873-1.939l-.136-.258ZM10 8.919c-3.061 0-5.834.268-8.317.801l-.183.04v1.514l.06.165c.624 1.653 1.438 2.422 2.44 2.422 1.05 0 1.894-.844 2.528-2.665a.5.5 0 0 1 .947.008c.601 1.817 1.441 2.657 2.525 2.657 1.084 0 1.924-.84 2.525-2.657a.5.5 0 0 1 .95.002c.593 1.816 1.432 2.655 2.525 2.655 1.078 0 1.909-.817 2.501-2.583L18.5 9.76l-.183-.04c-2.292-.492-4.831-.758-7.616-.796L10 8.919Zm.012-7.141-.204.369a9.864 9.864 0 0 0-.734 1.824c-.173.593-.042 1.166.426 1.74v-.85a.5.5 0 0 1 .992-.09l.008.09.001.865c.424-.519.571-1.05.465-1.609l-.036-.156a8.633 8.633 0 0 0-.779-1.944l-.139-.239Z"
        clipRule="evenodd"
      />
    </Svg>
  )
}
